
const {get} = require('../request')
const {posToName, posColour} = require('../pos')
const {parse} = require('../html')
const layout = require('./analysis.html')
const navLayout = require('./analysis_nav_item.html')

/*
 * 문서에 대한 각 분석을 나타내는 클래스
 */
const Analysis = class {
    constructor(api, document, config) {
        this.api = api
        this.document = document
        this.config = config
        this.summary = {}
        this.name = '분석'
        this.visualisers = []
    }
    run() {
        const {host, port} = this.api
        return new Promise((resolve, reject) => {
            get(host, port, `/document/${this.document.name}/tokens`, this.config.json()).then((result) => {
                if(result.error) return alert(result.error)
                const length = result.units.length
                const counts = result.units.map(unit => unit.tokens.length)
                const sumTokens = counts.reduce((a, c) => a + c, 0)
                const avgTokens = sumTokens / counts.length
                const names = result.units.map(unit => unit.name)
                this.summary = {length, sumTokens, avgTokens, names}
                resolve()
            }).catch((err) => reject(err))
        })
    }
    dom() {
        if(this.summary == {}) return '데이터를 불러올 수 없습니다.'
        const document = this.document
        const {tokenizer, section, limit, split, posList} = this.config
        const start = section + 1
        const end = start + limit - 1
        const pos = posList ? posList.map(pos => ({name: posToName(pos), colour: posColour(pos)}))
                .map(({name, colour}) => `<span style="color: ${colour}; font-weight: bold;">${name}</span>`)
                .filter((c, i, a) => i === a.indexOf(c)).join(', ') : null
        const config = {document, tokenizer, start, end, split, pos}
        const summary = this.summary
        const name = this.name
        const content = parse(layout, {name, config, summary}).querySelector('#content')
        return content
    }
    nav() {
        const content = parse(navLayout, {name: this.name}).querySelector('#content')
        return content
    }
}

module.exports = Analysis
